import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss']
})
export class ShareModalComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private logService: LogService
  ) { }

  @ViewChild("shareModalContent") private shareModalContent: ElementRef;  
  @Input() ean;

  ngOnInit() {
    // this.logService.printLog("share code",this.ean);
  }


  closeModal() {
    this.modalRef.close();
  }

  open() {
    if (localStorage.getItem('user') !== null) {
      this.modalRef = this.modalService.open(this.shareModalContent);
      // this.logService.printLog("Right modal opened");
      this.modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {
      this.frontEndService.confirmAlert("Title", 'Please login first', 'question', (response) => {
        this.logService.printLog("confirmAlert response", response);
        if(response.value) {
          
        }
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/share-modal/share-modal.component.ts